import React, { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { canSellFromCountry } from '../util/sellingAccess';
import { VisitorCountryContext } from './visitorCountryContext';

export const SellingAccessContext = createContext(false);
export const useCanCreateListings = () => useContext(SellingAccessContext);

export const SellingAccessProvider = ({ children }) => {
  const country = useSelector(state => state.sellingAccess?.country);
  return (
    <VisitorCountryContext.Provider value={country || null}>
      <SellingAccessContext.Provider value={canSellFromCountry(country)}>
        {children}
      </SellingAccessContext.Provider>
    </VisitorCountryContext.Provider>
  );
};

export const SellingAllowed = ({ children }) => (useCanCreateListings() ? children : null);
